import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'gen-template-parser',
  templateUrl: './template-parser.component.html',
  styleUrls: ['./template-parser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateParserComponent implements OnInit {

  @Input()
  public template: string;

  @Input()
  public items: {
    [prop: string]: Array<{ fileName: string, created: string}>
  };

  public setData(items, template) {
    this.items = items;
    this.template = template;
  }

  constructor() { }

  ngOnInit() {
  }

}
